(function () {
  const btn = document.querySelector(".scroll-top");
  if (!btn) return;

  let docHeight = 0;
  let viewportHeight = 0;
  let ticking = false;

  const measure = () => {
    docHeight = document.documentElement.scrollHeight;
    viewportHeight = document.documentElement.clientHeight;
  };

  const render = () => {
    ticking = false;
    btn.classList.toggle("show", window.scrollY > viewportHeight);

    const belowFold = docHeight - window.scrollY - viewportHeight;
    btn.style.setProperty(
      "--scroll-top-below-fold",
      Math.max(0, belowFold) + "px"
    );
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(render);
  };

  const remeasureAndUpdate = () => {
    measure();
    requestUpdate();
  };

  measure();
  render();

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", remeasureAndUpdate);

  window.addEventListener("load", remeasureAndUpdate);

  if ("ResizeObserver" in window) {
    new ResizeObserver(remeasureAndUpdate).observe(document.body);
  }

  document.addEventListener("shopify:section:load", remeasureAndUpdate);

  btn.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
})();
